import Service from "./Service";
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export class AssetService extends Service{
    constructor() {
        super();
        this.baseURL = 'asset';
    }

    findByCourseId(courseId) {
        return fetch(SERVER_URL + this.baseURL + '/findByCourseId/' + courseId, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    updateTimeEstimation(data) {
        return fetch(SERVER_URL + this.baseURL + '/updateTimeEstimation', {
            crossDomain: true,
            method: 'put',
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")},
            body: JSON.stringify(GeneralUtils.addUpdateInfo(data))
        }).then(response => {
                let result = response.clone();
                GeneralUtils.notification(response);
                return result.json();
            }
        ).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    // findByLectureId(lectureId) {
    //     return fetch(SERVER_URL + this.baseURL + '/findByLectureId/' + lectureId, {
    //         headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
    //     }).then(response => response.json()).catch(error => {
    //         GeneralUtils.notification(error);
    //     });
    // }
    //
    // findSupplementaryAssetsByLectureId(lectureId) {
    //     return fetch(SERVER_URL + this.baseURL + '/findSupplementaryAssetsByLectureId/' + lectureId, {
    //         headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
    //     }).then(response => response.json()).catch(error => {
    //         GeneralUtils.notification(error);
    //     });
    // }
    //
    // findPreviewByCourseId(courseId) {
    //     return fetch(SERVER_URL + this.baseURL + '/findPreviewByCourseId/' + courseId, {
    //         headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
    //     }).then(response => response.json()).catch(error => {
    //         GeneralUtils.notification(error);
    //     });
    // }
}